module.exports = __webpack_public_path__ + "img/man-exposures.ba8565ee.svg";